var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-recaptcha",attrs:{"id":"g-recaptcha","data-sitekey":_vm.sitekey,"data-action":_vm.action,"data-size":"invisible"}})
}
var staticRenderFns = []

export { render, staticRenderFns }